import React from 'react'
import PropTypes from 'prop-types'
import image3 from './image3.jpeg'

const CV_Kamen = () => {
    return (
        <div className="card" style={{flexBasis: 255, flexGrow: 0, marginBottom: 30}}>
            <img className="card-img-top" src={image3} alt="Card image cap"/>
            <div className="card-body">
                <h5 className="card-title">Проф. д.ф.н. Камен Михайлов</h5>
                <p className="card-text">Българска академия на науките, Институт за литература, Направление „Литература на Българското възраждане“.
                </p>
            </div>
            <div className="card-footer">
                <span  data-toggle="modal" data-target="#CVKamen" className="btn btn-danger" style={{width: '100%'}}>Научете повече</span>
            </div>
            <div className="modal fade" id="CVKamen" tabindex="-1" role="dialog" aria-labelledby="CVKamenLabel" aria-hidden="true">
                <div className="modal-dialog" style={{maxWidth: 640}}role="document">
                    <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="CVKamenLabel">Проф. д.ф.н. Камен Михайлов</h5>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <p>КАМЕН ВАСИЛЕВ МИХАЙЛОВ завършва българска филология и философия в Софийския университет „Климент Охридски“  (1978). Редовен аспирант е в Института за литература при БАН (1983). През 1984 г. работи като филолог-специалист. Защитава дисертационен труд „Жанрови проблеми в творчеството на П. Р. Славейков“ (1988). През 1990 става научен сътрудник I ст. (1990), а през 2001 г. старши научен сътрудник II ст. (2001). Хабилитационният му труд е „Текст и контекст у Ботев“ (2000). Става доктор на филологическите науки с изследването „Български/ булгарски образи в рускоезична среда“. От 2015 г. е професор. 
                        </p>
                        <p>Преподавал е дисциплините: Нова българска литература и Българска литература на журналисти в СУ „Климент Охридски“ (1978, 1979), Българска възрожденска литература в ПУ „Паисий Хилендарски“ (1989  – 1994), Българска възрожденска литература, Фолклор, Нова и Съвременна българска литература във Филиала на Пловдивския университет „Любен Каравелов“ – Кърджали (1995  – 2004). Бил е лектор по български език и култура в Брянския държавен университет „И. Г. Петровски“ (2005  – 2010), сега е лектор в Будапещенския университет „Лоранд Йотвьош“. До момента 17 негови статии и студии са публикувани в чужбина. Професионалните интереси на проф. Михайлов са в областите: история и теория на литературата, теория на цивилизациите. 
                        </p>
                        <h4>In Memoriam</h4>
                        <p style={{fontWeight: 'bold'}}>
                            Наскоро проф. д.ф.н. Камен Михайлов си отиде от света ни. Ние, неговите колеги, винаги ще го помним! С обич! С респект! И ще скърбим за приятеля,защото беше сърцат българин! 
                        </p>
                        <p style={{fontWeight: 'bold', textAlign: 'right'}}>
                            От екипа на Проекта
                        </p>

                        <h2>Избрани публикации:</h2>

                        <h3>Монографии:</h3>
                        <ul> 
                            <li>Камен Михайлов. Петко Славейков (1927 – 1895). Поетически послания. София: Ариадна, 2002.</li>
                            <li>Камен Михайлов. Текст и контекст у Ботев. София, 2000 (електронен вариант).</li>
                            <li>Камен Михайлов. Български/булгарски образи в рускоезична среда. София: Тангра ТанНакРа. 2014.</li>
                            <li>Камен Михайлов. Мемоаристиката на ранните руско-турски войни. 1783 –1830. София, Печатница DPХ, 2015.</li>
                        </ul>

                        <h3>Редакция и съставителство:</h3>
                        <ul>
                            <li>Камен Михайлов. Пенчо Славейков, „Съчинения“, Том I. Епика, София: Фигура, 2001, (съставителство, коментар и редакция), съвместно изпълнение със Ст. Михайлова.</li>
                            <li>Камен Михайлов. Пенчо Славейков, „Съчинения“, Том II. Лирика, София: Фигура, 2002, (съставителство, коментар и редакция), съвместно изпълнение със Ст. Михайлова.</li>
                            <li>Камен Михайлов. Историзмът на Михайло Ломоносов, историзмът на Паисий Хилендарски. // Език и литература, 2012, №№ 3  –  4, с. 41 – 60.</li>
                            <li>Камен Михайлов. Доклад на юбилейната научна конференция за Паисиевата история в Благоевград: „История славяноболгарская и хронографите“.  </li>
                        </ul>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" data-dismiss="modal">Затвори</button>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    )
}


export default CV_Kamen



// WEBPACK FOOTER //
// ./src/modules/OurTeam/CV_Kamen.jsx